<template>
  <AppTabRoute :tabs="tabs"></AppTabRoute>
</template>

<script>
export default {
  name: 'UserTabs',
  computed: {
    tabs() {
      return [
        { name: 'Usuários', route: 'user.list' },
        { name: 'Tipo de Usuário', route: 'user-type.list' },
      ];
    },
  },
};
</script>

<style>
</style>